import Vue from 'vue'
import { Ability } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'

Vue.use(abilitiesPlugin, new Ability())
